/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const EventObjectEnum = {

    /**
     * TODO: Write general description for this element
     */
    ENUM_0: 'activity',

    /**
     * TODO: Write general description for this element
     */
    ENUM_1: 'activityType',

    /**
     * TODO: Write general description for this element
     */
    ENUM_2: 'deal',

    /**
     * TODO: Write general description for this element
     */
    ENUM_3: 'note',

    /**
     * TODO: Write general description for this element
     */
    ENUM_4: 'organization',

    /**
     * TODO: Write general description for this element
     */
    ENUM_5: 'person',

    /**
     * TODO: Write general description for this element
     */
    ENUM_6: 'pipeline',

    /**
     * TODO: Write general description for this element
     */
    ENUM_7: 'product',

    /**
     * TODO: Write general description for this element
     */
    ENUM_8: 'stage',

    /**
     * TODO: Write general description for this element
     */
    ENUM_9: 'user',

    /**
     * TODO: Write general description for this element
     */
    ENUM_10: '*',

};

module.exports = EventObjectEnum;
